import React from 'react';
import ScriptFlows from '../components/workflow/ScriptFlows';

export default function ScriptFlowsPage({ selectedDevice }) {
  return <ScriptFlows selectedDevice={selectedDevice} />;
}
